import { render, staticRenderFns } from "./ControlDrugRegList.vue?vue&type=template&id=bca8b188"
import script from "./ControlDrugRegList.vue?vue&type=script&lang=js"
export * from "./ControlDrugRegList.vue?vue&type=script&lang=js"
import style0 from "./ControlDrugRegList.vue?vue&type=style&index=0&id=bca8b188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports